import Alpine from 'alpinejs';
import dialog from '@alpinejs/ui/src/dialog.js';
import popover from '@alpinejs/ui/src/popover.js';
import intersect from "@alpinejs/intersect";
import resize from "@alpinejs/resize";
import focus from "@alpinejs/focus";

Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(resize);
Alpine.plugin(dialog);
Alpine.plugin(popover);

document.addEventListener('DOMContentLoaded', () => {
    Alpine.start();
});
